import React from 'react';

// Packages
import { KiteButton, KiteGrid, KiteGridCell } from '@kite/react-kite';
import { EntAlertView, EntLayoutThreeColumn } from '@ent-ui-kit/react';

const NoPermission = () => {
  const handleRequestAccess = () => {
    window.open(
      'https://jira.charter.com/secure/CreateIssue.jspa?pid=34302&issuetype=50200',
      '_blank'
    );
  };

  return (
    <EntLayoutThreeColumn>
      <KiteGrid>
        <KiteGridCell col={12}>
          <EntAlertView
            type="error"
            title="Unable to Sign In"
            message="We’re sorry, you don’t have the permissions needed to sign in to Ops
            Center."
          />
        </KiteGridCell>
        <KiteGridCell col={12}>
          <KiteButton onClick={handleRequestAccess}>Request Access</KiteButton>
        </KiteGridCell>
      </KiteGrid>
    </EntLayoutThreeColumn>
  );
};

export default NoPermission;
